import axios from 'axios';

const backendUrl = `https://${process.env.REACT_APP_API_DNS}/api/activities`;

export const RecommendItems = async() => {
    try {
        const response = await axios.get(`${backendUrl}/trending`);
        return response.data;
    }catch(error){
        console.error('error: ', error);
        throw error;
    }
}

export const CategoryItems = async(city, category, data) => {
    try{
        const response = await axios.post(`${backendUrl}/search?city=${city}&category=${category}`,{
            selectedDay: data.selectedDay,
            adult: 1,
            child: 0
        });
        return response.data;
    }catch(error){
        console.error('error: ', error);
        throw error;
    }
}

export const LocationItems = async(city, data) => {
    try{
        const response = await axios.post(`${backendUrl}/search`, {
            city: city,
            selectedDay: data.selectedDay,
            adult: 1,
            child: 0
        });
        return response.data;
    }catch(error){
        console.error('error: ', error);
        throw error;
    }
}

export const GetItem = async(id) => {
    try {
      const response = await axios.get(`${backendUrl}/${id}`);
      return response.data;
} catch (error) {
      console.error('Error fetching item data:', error);
      throw error;
    }
  };

export const GetItemTickets = async (id, params = {}) => {
    try {
        const response = await axios.post(`${backendUrl}/${id}/tickets`, { params });
        return response.data;    
    } catch (error) {
        console.error(`Error fetching tickets for item ${id}:`, error);
        throw error;
    }
};
